import React from "react";
import Select from "react-select";

import { LineInput } from "components/Inputs/LineInput";

import { Button } from "aible";

import {
  BlueprintTile,
  ModelTile,
  DatasetTile,
  ConsultingTile,
  CreateTile
} from "components/MarketplaceDemo/Tiles/Tiles";
import { TypeIcon, Divider } from "components/Home/Utils/Utils";
import getStyles from "components/Home/Utils/getStyles";

import styles from "./style.module.css";

import aibleLogo from "images/marketplace/aible-logo.png";
import aibleRobot from "images/aibleBot.png";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";

import blueprintIcon from "images/marketplace/blueprint.png";
import modelIcon from "images/marketplace/model.png";
import dataIcon from "images/marketplace/data.png";
import consultingIcon from "images/marketplace/consulting.png";

import starFilled from "images/marketplace/star-filled.svg";
import starEmpty from "images/marketplace/star-empty.svg";

const CONSULTING_PRICE_MODIFIERS = [
  { value: "", label: "One Time Charge" },
  { value: "/month", label: "Per Month" }
];

const CONSULTING_PRICE_CONDITIONALS = [
  { value: "", label: "When the project is completed" },
  { value: "if results improve by >1%", label: "If the resulting model improves by more than 1%" }
];

const CARD_IMAGES = {
  blueprints: blueprintIcon,
  models: modelIcon,
  data: dataIcon,
  "data recipe": dataIcon,
  "data cleansing": dataIcon,
  consulting: consultingIcon
};

const CARD_HEADERS = {
  blueprints: styles.blueprintHeader,
  models: styles.modelHeader,
  data: styles.dataHeader,
  consulting: styles.consultingHeader,
  "data recipe": styles.dataHeader,
  "data cleansing": styles.dataHeader
};

function getImage(type) {
  return CARD_IMAGES[type] || "";
}

export default class Marketplace extends React.Component {
  state = {
    selected: "all",
    search: "",
    showDrawer: false,
    creating: false,
    buying: false,

    selectedItem: {},
    buyHandler: () => {}
  };

  createShowDrawerHandler(selectedItem, buyHandler, creating = false, buying = {}) {
    return (callback) =>
      this.setState(
        {
          showDrawer: true,
          buyHandler: () => {
            buyHandler();
            this.setState({ showDrawer: false, creating: false });
          },
          selectedItem,
          creating,
          buying
        },
        callback
      );
  }

  createCreateHandler(type) {
    const { history, createConsulting } = this.props;
    switch (type) {
      case "data":
      case "models":
        return () => {
          history.push("/");
        };
      case "blueprints":
        return () => {
          history.push("/blueprint/new");
        };
      case "consulting":
        return this.createShowDrawerHandler(
          { type: "consulting", name: "Create Expertise Offer" },
          () => {
            createConsulting(this.state.creating);
          },
          {}, //creating
          false //buying
        );
      default:
        return () => {};
    }
  }

  render() {
    const {
      blueprints,
      models,
      data,
      consulting,
      buyData,
      unbuyData,
      buyConsulting,
      unbuyConsulting,
      buyBlueprint,
      unbuyBlueprint,
      buyModel,
      unbuyModel,
      userID,
      history,
      allData,
      allBPs,
      deleteConsulting,
      getLinkedConsultants
    } = this.props;
    const { selected, showDrawer, selectedItem, buyHandler, creating, buying } = this.state;
    return (
      <div className={styles.marketplaceWrapper}>
        {/* <AibleBot>
				<p>{"Customize your experience with Blueprints and Models created by fellow EnAiblers!"}</p>
			</AibleBot> */}
        <div className={styles.marketplaceHeader}>
          <h1>Aible Marketplace</h1>
        </div>
        <SearchBar selected={selected} selectView={(filter) => this.setState({ selected: filter })} />
        <div className={styles.contentWrapper}>
          <div className={styles.tileWrapper + " " + (showDrawer ? styles.tileWrapperShrink : "")}>
            {selected !== "all" && <CreateTile type={selected} clickHandler={this.createCreateHandler(selected)} />}
            {(selected === "all" || selected === "blueprints") &&
              blueprints.map((blueprint) => {
                const parsedBP = {
                  name: blueprint.name,
                  type: "blueprints",
                  author: blueprint.created_by && blueprint.created_by.fullname,
                  purchased:
                    blueprint.wizard &&
                    blueprint.wizard.marketplace &&
                    (blueprint.wizard.marketplace.purchased ||
                      (blueprint.created_by && parseInt(blueprint.created_by.id) === userID)),
                  details:
                    (blueprint &&
                      blueprint.wizard &&
                      blueprint.wizard.marketplace &&
                      blueprint.wizard.marketplace.blueprintDetails) ||
                    {}
                };
                const consultants = getLinkedConsultants(blueprint.id);
                if (consultants && consultants.length > 0) {
                  blueprint = JSON.parse(JSON.stringify(blueprint));
                  const parsedDetails = JSON.parse(JSON.stringify(parsedBP.details));
                  const links = parsedDetails.links || {};
                  links.consultants = consultants;
                  blueprint &&
                    blueprint.wizard &&
                    blueprint.wizard.marketplace &&
                    blueprint.wizard.marketplace.blueprintDetails &&
                    (blueprint.wizard.marketplace.blueprintDetails.links = links);
                  parsedDetails.links = links;
                  parsedBP.details = parsedDetails;
                }
                return (
                  <BlueprintTile
                    key={blueprint.id}
                    blueprint={blueprint}
                    purchasedClickHandler={
                      blueprint.created_by && parseInt(blueprint.created_by.id) !== parseInt(userID)
                        ? () => unbuyBlueprint(blueprint.id)
                        : () => {}
                    }
                    clickHandler={this.createShowDrawerHandler(parsedBP, () => buyBlueprint(blueprint.id))}
                    isMarketplace
                    ownerActive={blueprint.created_by && parseInt(blueprint.created_by.id) === userID}
                    purchased={
                      blueprint.wizard && blueprint.wizard.marketplace && blueprint.wizard.marketplace.purchased
                    }
                  />
                );
              })}
            {(selected === "all" || selected === "models") &&
              models.map((model) => {
                const parsedModel = {
                  name: model.name,
                  type: "models",
                  author: model && model.created_by && model.created_by.fullname,
                  purchased: model && model.wizard && model.wizard.marketplace && model.wizard.marketplace.purchased,
                  details:
                    (model && model.wizard && model.wizard.marketplace && model.wizard.marketplace.modelDetails) || {}
                };
                return (
                  <ModelTile
                    key={model.id}
                    model={model}
                    purchasedClickHandler={() => unbuyModel(model.id)}
                    clickHandler={this.createShowDrawerHandler(parsedModel, () => buyModel(model.id))}
                    isMarketplace
                    ownerActive={false}
                    purchased={model.wizard && model.wizard.marketplace && model.wizard.marketplace.purchased}
                  />
                );
              })}
            {(selected == "all" || selected == "data") &&
              data.map((data, i) => {
                const dataBP = {
                  created_by: { fullname: data.author },
                  name: data.name,
                  wizard: {
                    marketplace: {
                      purchased: data.purchased,
                      datasetDetails: data.details
                    }
                  }
                };
                return (
                  <DatasetTile
                    key={i}
                    dataset={dataBP}
                    purchasedClickHandler={() => unbuyData(data.id)}
                    clickHandler={this.createShowDrawerHandler(data, () => buyData(data.id))}
                    isMarketplace
                    ownerActive={false}
                    purchased={data.purchased}
                  />
                );
              })}
            {(selected == "all" || selected == "consulting") &&
              consulting.map((consultant, i) => {
                const parsedConsultant = {
                  name: consultant.name,
                  type: "consulting",
                  author: consultant.created_by && consultant.created_by.fullname,
                  purchased:
                    consultant.wizard &&
                    consultant.wizard.marketplace &&
                    (consultant.wizard.marketplace.purchased ||
                      (consultant.created_by && parseInt(consultant.created_by.id) === userID)),
                  details:
                    (consulting &&
                      consultant.wizard &&
                      consultant.wizard.marketplace &&
                      consultant.wizard.marketplace.consultingDetails) ||
                    {}
                };
                const creatorId = consultant.created_by && parseInt(consultant.created_by.id);

                return (
                  <ConsultingTile
                    key={consultant.id}
                    consulting={consultant}
                    purchasedClickHandler={creatorId !== userID ? () => {} : () => deleteConsulting(consultant.id)}
                    clickHandler={this.createShowDrawerHandler(parsedConsultant, () =>
                      buyConsulting(consultant.id, this.state.buying)
                    )}
                    isMarketplace
                    ownerActive={creatorId === userID}
                    purchased={
                      consultant.wizard && consultant.wizard.marketplace && consultant.wizard.marketplace.purchased
                    }
                  />
                );
              })}
          </div>
          <MarketplaceDrawer
            show={showDrawer}
            handleHide={() => this.setState({ showDrawer: false, creating: false, buying: false })}
            selectedItem={selectedItem}
            buyHandler={buyHandler}
            creating={creating}
          >
            {selectedItem &&
              selectedItem.type === "consulting" &&
              ((creating && (
                <CreateConsulting
                  fields={creating}
                  updateField={(field, value) => {
                    const creating = this.state.creating;
                    creating[field] = value;
                    return this.setState({ creating });
                  }}
                  blueprints={blueprints}
                  allData={allData}
                />
              )) ||
                (buying && (
                  <BuyConsulting
                    fields={buying}
                    updateField={(field, value) => {
                      const buying = this.state.buying;
                      buying[field] = value;
                      return this.setState({ buying });
                    }}
                    blueprints={blueprints}
                    allBPs={allBPs}
                    allData={allData}
                  />
                )))}
          </MarketplaceDrawer>
        </div>
      </div>
    );
  }
}

class CreateConsulting extends React.PureComponent {
  render() {
    const { fields, updateField, blueprints, allData } = this.props;
    return (
      <div className={styles.createConsulting}>
        <div className={styles.inputLabel}>Name</div>
        <div className={styles.lineInput}>
          <LineInput onChange={(val) => updateField("name", val)} isBox isHeader />
        </div>
        <div className={styles.inputLabel}>Description</div>
        <div className={styles.textArea}>
          <textarea
            rows={3}
            onBlur={(event) => updateField("description", event.target.value)}
            placeholder={"What services are you providing?\nCreate Custom Blueprints\nDeploy from Blueprint..."}
          ></textarea>
        </div>
        <div className={styles.inputLabel}>Price</div>
        <PriceInput
          updatePrice={(val) => updateField("price", val)}
          updatePriceModifier={(val) => updateField("priceModifier", val)}
          priceModifierOptions={CONSULTING_PRICE_MODIFIERS}
          updatePriceConditional={(val) => updateField("priceConditional", val)}
          priceConditionalOptions={CONSULTING_PRICE_CONDITIONALS}
        />
        <div className={styles.inputLabel}>Link Blueprints</div>
        <Select
          placeholder={""}
          options={blueprints.map((bp) => ({
            label: bp.name + " by " + (bp && bp.created_by && bp.created_by.fullname),
            value: bp
          }))}
          isMulti
          onChange={(val) => {
            const links = fields.links || {};
            links.blueprints = val ? val.map(({ value }) => value) : [];
            return updateField("links", links);
          }}
          menuPlacement="top"
          className={styles.selectDropdown}
        />
        <div className={styles.inputLabel}>Link Datasets</div>
        <Select
          placeholder={""}
          options={allData.map((data) => ({
            label: data.label + " by " + (data && data.created_by && data.created_by.fullname),
            value: data
          }))}
          isMulti
          onChange={(val) => {
            const links = fields.links || {};
            links.data = val ? val.map(({ value }) => value) : [];
            return updateField("links", links);
          }}
          menuPlacement="top"
          className={styles.selectDropdown}
        />
      </div>
    );
  }
}

class PriceInput extends React.PureComponent {
  render() {
    const { updatePrice, updatePriceModifier, priceModifierOptions, updatePriceConditional, priceConditionalOptions } =
      this.props;
    return (
      <div className={styles.priceWrapper}>
        <div className={styles.priceInputWrapper}>
          <p>$</p>
          <div className={styles.lineInput + " " + styles.priceInput}>
            <LineInput
              className={styles.input}
              onChange={(val) => updatePrice(val)}
              inputType={"float"}
              min={0}
              isBox
              isHeader
            />
          </div>
          <p>USD</p>
          <Select
            placeholder={"Select a Pricing Model"}
            options={priceModifierOptions}
            onChange={(val) => updatePriceModifier(val.value)}
            menuPlacement="top"
            className={styles.priceModifierSelect}
          />
        </div>
        <Select
          placeholder={"When do you want customers to be charged?"}
          options={priceConditionalOptions}
          onChange={(val) => updatePriceConditional(val.value)}
          menuPlacement="top"
          className={styles.priceConditionalSelect}
        />
      </div>
    );
  }
}

class BuyConsulting extends React.Component {
  state = {
    showPrice: false
  };
  render() {
    const { fields, updateField, blueprints, allData, allBPs } = this.props;
    return (
      <div>
        <AibleBot>
          <p>What is the project you would like this consultant to work on?</p>
        </AibleBot>
        <div className={styles.createConsulting}>
          <div className={styles.inputLabel}>Name</div>
          <div className={styles.lineInput}>
            <LineInput onChange={(val) => updateField("name", val)} isBox isHeader />
          </div>
          <div className={styles.inputLabel}>Description</div>
          <div className={styles.textArea}>
            <textarea rows={3} onBlur={(event) => updateField("description", event.target.value)}></textarea>
          </div>
          <div className={styles.inputLabel}>Provide Blueprint Access</div>
          <Select
            placeholder={""}
            options={allBPs.map((bp) => ({
              label: bp.name + " by " + (bp && bp.created_by && bp.created_by.fullname),
              value: bp
            }))}
            isMulti
            onChange={(val) => {
              const links = fields.links || {};
              links.blueprints = val ? val.map(({ value }) => value) : [];
              return updateField("links", links);
            }}
            menuPlacement="top"
            className={styles.selectDropdown}
          />
          <div className={styles.inputLabel}>Provide Dataset Permissions (metadata and runs only)</div>
          <Select
            placeholder={""}
            options={allData.map((data) => ({
              label: data.label + " by " + (data && data.created_by && data.created_by.fullname),
              value: data
            }))}
            isMulti
            onChange={(val) => {
              const links = fields.links || {};
              links.data = val ? val.map(({ value }) => value) : [];
              return updateField("links", links);
            }}
            menuPlacement="top"
            className={styles.selectDropdown}
          />
          <AibleBot>
            <p>Please set the cost or size limits for this project.</p>
          </AibleBot>
          <div className={styles.inputLabel}>Model run cost limit (0 for none)</div>
          <div style={{ padding: "0px 25px" }}>
            <div className={styles.priceInputWrapper}>
              <p>$</p>
              <div className={styles.lineInput + " " + styles.priceInput}>
                <LineInput
                  className={styles.input}
                  onChange={(val) => updateField("costLimit", val)}
                  inputType={"float"}
                  min={0}
                  isBox
                  isHeader
                />
              </div>
              <p>USD</p>
            </div>
          </div>
          <div className={styles.inputLabel}>Upload size limit in Mb (0 for none)</div>
          <div className={styles.lineInput} style={{ maxWidth: "150px", padding: "0px 25px" }}>
            <LineInput onChange={(val) => updateField("sizeLimit", val)} inputType={"float"} min={0} isBox isHeader />
          </div>
        </div>
      </div>
    );
  }
}

class AibleBot extends React.PureComponent {
  render() {
    return (
      <div className={styles.greetingWrapper}>
        <div className={styles.aibleBot}>
          <img src={aibleRobot} alt="Aible Bot" />
        </div>
        <div className={styles.speechBubble}>{this.props.children}</div>
      </div>
    );
  }
}

class SearchBar extends React.PureComponent {
  render() {
    const { selected, selectView } = this.props;
    return (
      <div className={styles.searchBar}>
        <div className={styles.filters}>
          <FilterTab label={"all"} selected={selected} selectView={selectView} />
          <FilterTab label={"blueprints"} selected={selected} selectView={selectView} />
          <FilterTab label={"models"} selected={selected} selectView={selectView} />
          <FilterTab label={"data"} selected={selected} selectView={selectView} />
          <FilterTab label={"consulting"} selected={selected} selectView={selectView} />
        </div>
      </div>
    );
  }
}

class FilterTab extends React.PureComponent {
  render() {
    const { label, selected, selectView } = this.props;
    const image = getImage(label);
    return (
      <div
        className={`${styles.filterTab} ${selected === label ? styles.selected : ""}`}
        onClick={() => selectView(label)}
      >
        <TypeIcon border={selected === label} round size={"20px"} type={label} />
        <p style={(!image && { marginRight: "10px", marginLeft: "10px" }) || {}}>
          {label !== "consulting" ? label : "Expertise"}
        </p>
      </div>
    );
  }
}

class MarketplaceDrawer extends React.PureComponent {
  render() {
    const { show, handleHide, selectedItem, buyHandler, creating } = this.props;
    const type = selectedItem.type || "";
    return (
      <div className={styles.marketDrawerWrapper + " " + (show ? "" : styles.hideMarketDrawer)}>
        {/* <div className={styles.marketDrawerBranding}>
					<img src={aibleLogo} alt="Aible" />
					<h1>Marketplace</h1>
				</div> */}
        <div className={styles.marketDrawer}>
          <div className={styles.drawerClose} onClick={handleHide}>
            <FontAwesomeIcon icon={faTimes} />
          </div>
          <DrawerHeader type={type} name={selectedItem.name || ""} />
          {!creating ? <DrawerDetails {...selectedItem} /> : ""}
          {this.props.children}
          <div style={{ flexGrow: 1 }}></div>
          <DrawerFooter type={type} creating={creating} clickHandler={buyHandler} />
        </div>
      </div>
    );
  }
}

class DrawerHeader extends React.PureComponent {
  render() {
    const { type, name } = this.props;
    const typeStyles = getStyles(type);
    if (typeStyles) {
      return (
        <div className={styles.drawerHeader + " " + typeStyles.background}>
          <h3 className={typeStyles.text}>{name}</h3>
          {typeStyles.image && <img src={typeStyles.image} alt={type} />}
        </div>
      );
    } else return false;
  }
}

class DrawerDetails extends React.PureComponent {
  render() {
    const { name, author, type, details } = this.props;
    const price = details && details.price !== undefined ? details.price : 0;
    const rating = details && details.rating !== undefined ? details.rating : 0;
    const reviews = details && details.reviews !== undefined ? details.reviews : 0;
    const priceModifier = details && details.priceModifier !== undefined ? details.priceModifier : "";
    const priceConditional = details && details.priceConditional !== undefined ? details.priceConditional : "";
    const description = details && details.description !== undefined ? details.description : "";
    return (
      <div className={styles.drawerDetails}>
        <h2>
          <span>{(type + "").replace(/s\s*$/, "")} </span>by {author}
        </h2>
        <CardRating large rating={rating} reviews={reviews} />
        <div className={styles.drawerDetailsPrice}>
          <p>{price > 0 ? "$" + parseFloat(price).toFixed(2) + priceModifier : "Free"}</p>
          {priceConditional ? <h5>{priceConditional}</h5> : ""}
        </div>
        <Divider />
        <p>{description}</p>
        {details && details.links && <MarketConnections type={type} links={details && details.links} />}
      </div>
    );
  }
}

class MarketConnections extends React.Component {
  state = {
    show: true
  };
  render() {
    const { links, type } = this.props;
    const numLinks = links && Object.values(links).reduce((accum, arr) => (arr ? accum + arr.length : accum), 0);
    return (
      numLinks > 0 && (
        <div className={styles.marketConnections}>
          <div
            className={styles.marketConnectionsDetails + (this.state.show ? "" : " " + styles.marketConnectionsHide)}
          >
            {links &&
              Object.keys(links).map((key, i) =>
                links[key] && links[key].length > 0 ? <ConnectionsList key={i} type={key} list={links[key]} /> : ""
              )}
          </div>
        </div>
      )
    );
  }
}

class ConnectionsList extends React.PureComponent {
  render() {
    const { type, list } = this.props;
    return (
      <div className={styles.connectionsList}>
        <h1>
          <TypeIcon border size={"28px"} type={type} />
          {type}
        </h1>
        {list &&
          list.map((item, i) => (
            <p key={i}>
              {item.label || item.name} by {(item.created_by && item.created_by.fullname) || item.author}
            </p>
          ))}
      </div>
    );
  }
}

// This needs to work like react-select, but with icons
// use this for selection of blueprints, datasets, and models
class SelectIcons extends React.Component {
  state = {
    selected: []
  };
  createClickHandler() {}
  render() {
    const { options } = this.props;
    return <div>Hello World!</div>;
  }
}

class DrawerFooter extends React.PureComponent {
  render() {
    const { clickHandler, type, creating } = this.props;
    let buttonText =
      creating && type === "consulting"
        ? "Create Expertise Offer"
        : creating && type !== "consulting"
          ? "Create " + type + (type === "consulting" ? " Offer" : "")
          : "Add to My " + type;
    return (
      <div className={styles.drawerFooter}>
        <Divider />
        <Button type="secondary" onClick={clickHandler}>
          {buttonText}
        </Button>
      </div>
    );
  }
}

class CardRating extends React.PureComponent {
  render() {
    const { rating, reviews, large } = this.props;
    const ratingArr = [];
    for (let i = 0; i < 5; i++) {
      ratingArr.push(Math.round(rating) > i ? 1 : 0);
    }
    return (
      <div className={styles.ratingWrapper + " " + (large ? styles.ratingLarge : "")}>
        <div className={styles.starWrapper}>
          {ratingArr.map((star, index) => (
            <img key={index} src={star ? starFilled : starEmpty} alt={"Rating Star"} />
          ))}
        </div>
        <p>
          {reviews} review{parseInt(reviews) !== 1 ? "s" : ""}
        </p>
      </div>
    );
  }
}
